import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.334 8V1L1.33398 12H8.33399L8.33399 19L17.334 8L10.334 8Z" />
  </svg>
);
